export var FeatureFlagNames = /*#__PURE__*/ function(FeatureFlagNames) {
    FeatureFlagNames["ResumeOnePager"] = "ResumeOnePager";
    FeatureFlagNames["SelfServeRecruiting"] = "SelfServeRecruiting";
    FeatureFlagNames["SelfServeRecruitingExposeCandidateContactInfo"] = "SelfServeRecruiting-ExposeCandidateContactInfo";
    FeatureFlagNames["MS_SSO_Multitenant"] = "MS-SSO-Multitenant";
    return FeatureFlagNames;
}({});
